import colorConfigs from "../../configs/colorConfigs";

const verifyOtpPageStyles = {
    section: {
        backgroundColor: colorConfigs.secondary,
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    paper: {
        p: 0,
        borderRadius: 2,
        backgroundColor: colorConfigs.secondary,
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 2,
    },
    logoImage: {
        width: 100,
    },
    title: {
        fontWeight: 'bold',
        color: colorConfigs.textColor,
    },
    subtitle: {
        color: colorConfigs.greytext,
    },
    otpInput: {
        '& .MuiInputBase-input': {
            fontSize: '18px',
            textAlign: 'center',
            color: colorConfigs.textColor,
            backgroundColor: colorConfigs.subtleBackground,
            borderRadius: '8px',
            padding: '12px 14px',
        },
    },
    button: {
        marginTop: 2,
        color: colorConfigs.secondary,
        backgroundColor: colorConfigs.primary,
        '&:hover': {
        backgroundColor: colorConfigs.primary,
        },
        borderRadius: '30px',
    },
    resendText: {
        marginTop: 2,
        textAlign: 'center',
    },
};

export default verifyOtpPageStyles;